import { CashierConfiguration } from '@cashier/cashier-model';

import { CASHIER_CONFIGURATION_FEATURE_KEY } from './cashierConfiguration.slice';

export const selectCashierConfiguration = (
  rootState: any,
): CashierConfiguration => rootState[CASHIER_CONFIGURATION_FEATURE_KEY];
